import ApiClient from '@/api/client';
const path = require('path');

class UsersAPI extends ApiClient {

  constructor() {
    super();
  }

  async getUsersList(filters, page = 1) {
    let route = path.join(
      this.USERGROUP_API_PATH,
      `users/?page=${page}`
    );
    for (const filter in filters) {
      route = route.concat('', `&${filter}=${filters[filter].join(',')}`);
    }
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async orderUsersList(direction, field, filters, page) {
    let route;
    if (page) {
      route = path.join(
        this.USERGROUP_API_PATH,
        `users/?ordering=${direction}${field}&page=${page}`
      );
    } else {
      route = path.join(
        this.USERGROUP_API_PATH,
        `users/?ordering=${direction}${field}`
      );
    }
    for (const filter in filters) {
      route = route.concat('', `&${filter}=${filters[filter].join(',')}`);
    }
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async getUser(id) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `users/${id}/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async createUser(data) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      'users/'
    );
    const response = await this.post(route, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }
  async updateUser(id, data) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `users/${id}/`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async patchUser(id, data) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `users/${id}/`
    );
    const response = await this.patch(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async addUserToOrganisation(id, data) {
    const route = path.join(
      `${i18n.locale}${this.USERGROUP_API_PATH}`,
      `users/${id}/`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async deleteUser(id) {
    const route = path.join(
      this.USERGROUP_API_PATH,
      `users/${id}/`
    );
    const response = await this.delete(route);
    if (response.status === 204) {
      return true;
    }
    return false;

  }
};
const usersAPI = new UsersAPI();
export default usersAPI;
